import React from "react";
import { render } from "react-dom";
import { Router, Route, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import { unregister } from "./serviceWorker";

import "./index.css";
import "./utils/Format";

import App from "./screens/App";
import Payments from "./screens/Payments";
import Login from "./screens/Login";
import Register from "./screens/Register";
import Users from "./screens/Users";
import Customers from "./screens/Customers";
import PaymentErrors from "./screens/PaymentErrors";
import Dashboard from "./screens/Dashboard";


export const history = createBrowserHistory();

render(
  <div>
    <Router history={history}>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/register" component={Register} />
        <App>
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/users" component={Users} />
          <Route exact path="/customers" component={Customers} />
          <Route exact path="/payments" component={Payments} />
          <Route exact path="/payment-errors" component={PaymentErrors} />
        </App>
      </Switch>
    </Router>
  </div>,
  document.getElementById("root")
);
unregister();
